// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_oh-5";
export var filledCircle = "_oh-4";
export var historyEntry = "_oh-3";
export var messageSideLeft = "_oh-1";
export var messageSideRight = "_oh-2";
export var orderTrackingCarouselWrapper = "_oh-6";
export var orderTrackingInfoContainer = "_oh-0";